import { FreeDataWrapper, FreeDataCriteria, FreeDataScenario, Baseline } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { Model } from '../../../model/model';
import { ExternalAPI } from '../../../model/external-api';
import { FreedataValueVO } from '../../../vo/core/freedatavalue.vo';
import { FeiKeyDef, WidgetLine } from '@wizeoo/akm-compute-lib';
import { FeiVO } from '../../../vo/workingdata/fei.vo';

/**
 * prochaine séquence de FDV
 */
export class FreedataSeqCmd extends WizCommand<number> {
  
  protected model: Model = null;

  public nextID: number = -1;
  public fdv: FreedataValueVO = null;
  public fei: FeiVO = null;
  public fkd: FeiKeyDef = null;
  public wl: WidgetLine = null;
  public viewCallback: Function = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }
  
  /** retourne un wrapper pre-alimenté pour un appel complet du FD (avec values) */
  public  freedataWrapper(): FreeDataWrapper {
    const wrapper: FreeDataWrapper = new FreeDataWrapper();
    wrapper.criteria = new FreeDataCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.scenario = new FreeDataScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    wrapper.scenario.manageArgs = true;
    wrapper.scenario.manageLevels = false;
    wrapper.scenario.manageValues = false;
    return wrapper;
  }

  /** 
   * collecte de séquence pour un FDV
   * 
   * @param callback de retour
   * @returns la commande préparée
   */
  public getSequence(fdv: FreedataValueVO, callback: Function): FreedataSeqCmd {
    const wrapper: FreeDataWrapper = this.freedataWrapper();
    this.fdv = fdv;
    // this.viewCallback = callback;
    this.configureRemote(ExternalAPI.FREEDATA_SEQUENCE_API, wrapper, callback);
    return this;
  }

  /** 
   * collecte de la séquence pour une création de WL
   * 
   * @returns la commande préparée
   */
  public getSequenceForBaseline(fei: FeiVO, fkd: FeiKeyDef, wl: WidgetLine, callback: Function, viewCallback: Function = null): FreedataSeqCmd {
    const wrapper: FreeDataWrapper = this.freedataWrapper();
    this.fei = fei;
    this.wl = wl;
    this.fkd = fkd;
    this.callback = callback;
    this.viewCallback = viewCallback;
    this.configureRemote(ExternalAPI.FREEDATA_SEQUENCE_API, wrapper, callback);
    return this;
  }

  public wizResult(): void {
    if (this.result) {
      this.nextID = this.result;
    } else {
      console.log('FreedataSeqCmd no result');
    }
    super.wizResult();
  }
}
